<template>
  <b-container class="py-4">
    <b-row>
      <b-col md="4" class="mb-4">
        <router-link :to="prev" class="button-orange">
          <font-awesome-icon icon="arrow-circle-left" class="icon"></font-awesome-icon> Palaa edelliseen
        </router-link>
      </b-col>
      <b-col md="8">
        <h1>Hankkeen tiedot</h1>
      </b-col>
    </b-row>
    <b-row v-if="userSelection.kayttotarkoitus === null || userSelection.kerrosmaara === null">
      <b-col md="8" offset-md="4">
        <p>Ei määriteltyä hanketta.</p>
        <router-link to="/puunkaytonmahdollisuus"><font-awesome-icon icon="edit"></font-awesome-icon> Määritä hankkeen tiedot</router-link>
      </b-col>
    </b-row>
    <b-row v-if="userSelection.kayttotarkoitus !== null && userSelection.kerrosmaara !== null">
      <b-col md="8" offset-md="4">
        <table>
          <tr>
            <td width="180"><strong>Käyttötarkoitus:</strong></td>
            <td>{{kayttotarkoitus}}</td>
          </tr>
          <tr>
            <td><strong>Henkilömäärä:</strong></td>
            <td>{{userSelection.henkilomaara}}</td>
          </tr>
          <tr>
            <td><strong>Sprinklaus:</strong></td>
            <td>{{userSelection.sprinklaus}}</td>
          </tr>
          <tr>
            <td><strong>Kerrosala:</strong></td>
            <td>{{userSelection.kerrosala}} m<sup>2</sup></td>
          </tr>
          <tr>
            <td><strong>Kerrosmäärä:</strong></td>
            <td>{{userSelection.kerrosmaara}}</td>
          </tr>
          <tr>
            <td><strong>Palo-osaston koko:</strong></td>
            <td> {{userSelection.tilat}} m<sup>2</sup></td>
          </tr>
        </table>
      </b-col>
    </b-row>
    <b-row v-if="userSelection.kayttotarkoitus !== null || userSelection.kerrosmaara !== null">
      <b-col md="6" offset-md="4" class="my-4">
        <router-link to="/puunkaytonmahdollisuus">
          <font-awesome-icon icon="edit"></font-awesome-icon> Muuta hankkeen valintoja
        </router-link>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="6" offset-md="4">
        <router-link :to="next" v-if="(userSelection.results.p1 || userSelection.results.p2 || userSelection.results.p3) && this.$route.name != 'Kilpailuta'" class="button-orange">
          <font-awesome-icon icon="arrow-circle-right" class="icon"></font-awesome-icon> Seuraava
        </router-link>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import kayttotarkoitukset from '../data/kayttotarkoitukset.js'
export default {
  name: 'Tiedot',
  data () {
    return {
      kayttotarkoitukset: kayttotarkoitukset
    }
  },
  methods: {},
  computed: {
    kayttotarkoitus: function () {
      return this.userSelection.kayttotarkoitus != null ? this.kayttotarkoitukset[this.userSelection.kayttotarkoitus].label : ''
    },
    prev: function () {
      switch (this.$route.name) {
        case 'Jarjestelmat':
          return '/puunkaytonmahdollisuus'
        case 'Rakennetyypit':
          return '/jarjestelmat'
        case 'Kustannukset':
          return '/rakennetyypit'
        case 'Kilpailuta':
          return '/kustannukset'
      }
      return '/'
    },
    next: function () {
      switch (this.$route.name) {
        case 'Jarjestelmat':
          return '/rakennetyypit'
        case 'Rakennetyypit':
          return '/kustannukset'
        case 'Kustannukset':
          return '/kilpailuta'
        case 'Kilpailuta':
          return '/'
      }
      return '/'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Tiedot.vue